import {axiosUtil} from "../../../utils/axios_util";
const TaskManage = {
  //列表分页查询
  getTaskPage(data:any) {
    return axiosUtil({
        url: '/ai/bot/page',
        method: 'post',
        data,
        params: {
            page: data.page,
            size: data.size
        }
    })
  },
  //查询所有机器人
  getAllTask() {
    return axiosUtil({
        url: `/ai/bot/AllList`,
        method: 'post',
    })
},


}

export default TaskManage